import React from 'react';
import '../../styles/CarelonRx/modal.css';

interface CancelMFAModalProps {
  show: boolean;
  onDismiss: () => void;
  onConfirm: () => void;
}

const CancelMFAModal: React.FC<CancelMFAModalProps> = ({
  show,
  onDismiss,
  onConfirm
}) => {
  if (!show) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-content-section">
          <h2 className="modal-title">Are you sure you want to cancel?</h2>
          <p className="modal-description">
            If you do, you won't be able to log in and manage your pharmacy benefits.
          </p>
        </div>
        <div className="modal-actions">
          <button onClick={onDismiss} className="modal-btn-cancel">
            No, Don't Cancel
          </button>
          <button onClick={onConfirm} className="modal-btn-stay">
            Yes, Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default CancelMFAModal;
